import { GetLookupResponse } from '../../Services/ClientProxy/clientProxy';

export const LOAD_REFERENCE_DATA = 'LOAD_REFERENCE_DATA';

export interface LoadReferenceDataAction {
    type: typeof LOAD_REFERENCE_DATA;
    payload: {
        taxPayersConfig: GetLookupResponse;
    };
}

export type ReferenceDataActionTypes = LoadReferenceDataAction;
